const requisitionCreateInputsGroupsByHash = {
  orderingPhysician: {
    title: "",
    inputsById: [
      "collaborator",
      "clientId",
      "orderingClientPhysId",
      "isProviderSignature",
      "clientOrderId",
    ],
    inputsGroupsByHash: {
      group1: {
        ids: [
          [
            "collaborator",
            "clientId",
            "orderingClientPhysId",
            "isProviderSignature",
            "clientOrderId",
          ],
        ],
        inputWrapStyles: "width: 25%; max-width: none;",
      },
    },
    inputsGroupsById: ["group1"],
  },
  createPatient: {
    title: "",
    inputsById: [
      "patientDob",
      "patientLastName",
      "patientFirstName",
      "patientMiddleName",
      "patientGenderCode",
      "isDiabetic",
      "isFamilyHistory",
    ],
    inputsGroupsByHash: {
      patientInfo: {
        ids: [
          [
            "patientDob",
            "patientLastName",
            "patientFirstName",
            "patientMiddleName",
          ],
          [
            "patientGenderCode",
            "isDiabetic",
            "isFamilyHistory",
          ],
        ],
        groupStyles: "display: block; padding: 10px 0 0;",
      },
    },
    inputsGroupsById: ["patientInfo"],
  },
  specimenInformation: {
    title: "",
    inputsById: [
      "dateCollected",
      "timeCollected",
      "timeCollectedAmPm",
      "collectCode",
      "collectedBy",
      "testOrderedCodes",
      "specContainerTypeCode",
      "specimenConditionCode",
      "tubeCount",
      "panelIds",
      "testIds",
      "dateReceived",
      "timeReceived",
      "dateReceivedAmPm",
    ],
    inputsGroupsByHash: {
      group1: {
        ids: [
          [
            "testOrderedCodes",
            "specContainerTypeCode",
            "specimenConditionCode",
            "tubeCount",
          ],
        ],
      },
      collectedGroup: {
        title: "Date Collected",
        ids: [
          [
            "dateCollected",
            "timeCollected",
            "timeCollectedAmPm",
          ],
        ],
      },
      receivedGroup: {
        title: "Date Received",
        ids: [
          [
            "dateReceived",
            "timeReceived",
            "dateReceivedAmPm",
          ],
        ],
      },
      testsGroup: {
        title: "Tests",
        ids: [
          ["panelIds", "testIds"],
        ],
        inputWrapStyles: "width: 50%; max-width: none;",
        groupStyles: "display: block; padding: 20px 0 0;",
      },
    },
    inputsGroupsById: ["collectedGroup", "receivedGroup", "group1", "testsGroup"],
  },
  billingInformation: {
    title: "",
    inputsById: [
      "reqBillTypeCode",
      "isInsCardProvided",
      "isSelfPayProvided",
      "isIcdProvided",
      "patientEmail",
      "failIds",
      "guarantorAddr1",
      "guarantorAddr2",
      "guarantorCity",
      "guarantorStateId",
      "guarantorZip",
      "guarantorCountryId",
    ],
    inputsGroupsByHash: {
      group1: {
        ids: [
          [
            "reqBillTypeCode",
            "isInsCardProvided",
            "isSelfPayProvided",
            "isIcdProvided",
            "patientEmail",
          ],
        ],
        inputWrapStyles: "width: 20%; max-width: none;",
      },
      guarantorAddress: {
        title: "Patient or Guarantor Address",
        ids: [
          ["guarantorAddr1", "guarantorAddr2", "guarantorCity", "guarantorCountryId", "guarantorStateId", "guarantorZip"],
        ],
        inputWrapStyles: "width: 20%; max-width: none;",
        groupStyles: "display: block; padding: 0;",
      },
      issuesGroup: {
        title: "",
        ids: [
          ["failIds"],
        ],
        inputWrapStyles: "max-width: none;",
        groupStyles: "display: block; padding: 0;",
      },
    },
    inputsGroupsById: ["group1", "guarantorAddress", "issuesGroup"],
  },
};

export default requisitionCreateInputsGroupsByHash;
